import { render, staticRenderFns } from "./textLeftEnd.vue?vue&type=template&id=6280dab3&scoped=true&"
import script from "./textLeftEnd.vue?vue&type=script&lang=js&"
export * from "./textLeftEnd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6280dab3",
  null
  
)

export default component.exports